import { LoadState } from "../../../constants/enums";

export interface IBankDebitCreditState {
  list: IBankDebitCredit[];
  loading: LoadState;
  totalRecords: number;

  glDetail: IGeneralLedgerDetail[];
  glDetailLoading: LoadState;
}

export interface IGeneralLedgerDetail {
   gl_invoice_entry_id: number;
  gl_invoice_entry_code: string;
  gl_invoice_entry_date: string;
  transaction_date: string; 
  transaction_effective_date: string; // e.g., "2025-09-05"
  gl_invoice_entry_type: string; // e.g., "invoice"
  source_id: string;
  source_item_id: string;
  name: string;
  code: string;
  policy_number: string;
  branch_code: string | null;
  gl_account_id: string;
  gl_account_code: string;
  gl_account_type: string; // e.g., "I"
  gl_account_name: string;
  balance_sheet_or_income_statement_account: string; // e.g., "I"
  amount_debit: string; // numeric string like "96.96"
  amount_credit: string; // numeric string like "0.00"
  comment: string;
  status: string; // e.g., "ACTIVE"
  created_by_id: number;
  created_by_name: string | null;
  modified_by_id: number;
  modified_by_name: string | null;
  create_ts: string; // ISO date string
  insert_ts: string; // ISO date string
}

export interface IBankDebitCredit {
   
bank_account: string;
credit: string;
debit: string;
name: string;
transaction_date: string

}


export const initialBankCreditDebitState: IBankDebitCreditState = {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,

    glDetail: [],
    glDetailLoading: LoadState.NotLoaded,
}